export default "__VITE_ASSET__d2e909ce__"